<template>
  <div class="box">
    <div class="header">  
      <img  @click="goIndex" src="../image/logo.png" alt="">
      <h3>consultexperts</h3>
      <img  @click="goList" class="list"  src="../image/liebiao.png" alt="">
      </div>
 
 




<div class="dropDowm">
<el-dropdown @command="handleCommand"  trigger="click">
  <span class="el-dropdown-link">
    {{SelectTetx  || 'Select a theme'}}<i class="el-icon-arrow-down el-icon--right"></i>
  </span>
  <el-dropdown-menu slot="dropdown">
      <el-dropdown-item command="Health">Health</el-dropdown-item>
    <el-dropdown-item command="Healthy">Healthy</el-dropdown-item>
    <el-dropdown-item command="Parenting">Parenting</el-dropdown-item>
    <el-dropdown-item command="Finance">Finance</el-dropdown-item>
    <el-dropdown-item command="Medical">Medical</el-dropdown-item>
    <el-dropdown-item command="Food">Food</el-dropdown-item>
     <el-dropdown-item command="Scenery">Scenery</el-dropdown-item>
      <el-dropdown-item command="Travel">Travel</el-dropdown-item>
       <el-dropdown-item command="Hair Care">Hair Care</el-dropdown-item>
        <el-dropdown-item command="Beauty">Beauty</el-dropdown-item>
         <el-dropdown-item command="Sports">Sports</el-dropdown-item>
          <el-dropdown-item command="Weight Loss">Weight Loss</el-dropdown-item>
           <el-dropdown-item command="ALL">ALL</el-dropdown-item>
  </el-dropdown-menu>
</el-dropdown>
</div>


<div class="recommend" v-for="(item,index) in dataList" :key="index"  @click="goDetail(item)">
   <div class="recommend_die">

        <div class="recommend_img">
<img :src=item.img alt="" srcset="">

<div class="recommend_text">
  <h4>{{item.game_name}}</h4>
 
</div>
      </div>

    </div>
</div>



<div class="list_item"> 
  <div class="list_die" v-for="item1  in 4" :key="item1" @click="goDetail(classItem[item1])">

        <div class="cont_img">
<img :src=classItem[item1].img alt="" srcset="">

<div class="cont_text">
  <h3>{{classItem[item1].game_name}}</h3>
</div>
      </div>

    </div>

    </div>


 <div class="footer">
<a href="/#/privacy">privacy</a>
<a href="/#/terms">terms</a>
 </div>
  </div>
</template>

<script>
import   {  getDataList }  from "../../data/gameData_19"
export default {
  name: "omniscientIndex",
      data(){
    return{
      dataList: getDataList(),
      SelectTetx:null,
      classItem:null,
    }

  },
    created(){
this.classItem = this.swiperList(12)
  },
  methods: {
    
       handleCommand(command) {
        if (command == 'ALL') {
             this.dataList = getDataList()
             this.SelectTetx = 'ALL'
        }else{
    this.dataList = getDataList()
        var list = []
       console.log(command);
       this.dataList.forEach((item,index) =>{
        if (item.class == command) {
          list.push(item)
        }
       })
       this.SelectTetx = command
       this.dataList = list
        }
    
      },
      goIndex(){
       window.location.href = '/'
      },
      goList(){

        
       location.reload()
      },
           goDetail(value){
        if (value.id < 19) {
          window.location.href = `/detail${value.id}.html`
        }else{
          window.location.href = `/detail19.html?id=${value.id}`
        }
        
        
      },
          swiperList(value) {
  // 在回调函数中使用数据
  var dataCopy = this.dataList.map(element => element);
  var arrNew = [];

  for (var i = 0; i < value; i++) {
    var _num = Math.floor(Math.random() * dataCopy.length);
    var mm = dataCopy[_num];
    // 从复制的数组中移除已选择的元素
    dataCopy.splice(_num, 1);
    arrNew.push(mm);
  }
 
  return arrNew;

  // 这里可以进行后续的同步操作
},
}
  };
</script>

<style lang="less" scoped>

.box {
  min-height: 100vh;
max-width: 700px;
margin: auto;
}
.header {
     height: 80px;
    display: flex;
    font-size: 1.6rem;
    box-shadow: 0 2px 24px 0 rgba(0, 0, 0, 0.25);
    align-items: center;
        justify-content: space-around;
}
.header img{
  height: 100%;
}
.header h3{
    width: 68%;
    line-height: 80px;
    color: #679571;
    font-size: 20px;
    text-align: center;
    font-family: sans-serif;
}
.header .list{
  height: 60%;
}
.swiper_cont{
  margin: 20px;
  height: 300px;
}
  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 300px;
    text-align: center;
    margin: 0;
  }

/deep/ .el-dropdown{
  font-size: 20px;
  font-weight: 600;
      color: white;
}

/deep/ .el-carousel__container{
  height: 300px !important;
}
  .el-carousel__item:nth-child(2n) {
     background-color: #99a9bf;
  }
  
  .el-carousel__item:nth-child(2n+1) {
     background-color: #d3dce6;
  }

.list_item{
    max-width: 700px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin: auto;
}

  .list_die{
    cursor: pointer;
     display: flex;
    height: 270px;
       width: 77%;
 transition: all 0.5s ease-in-out;
    margin: 20px;

  }
   .cont_img{
       height: 320px;

   }
  .cont_img img{
  box-shadow: 1px 0px 40px #b8b8b8, -15px -15px 40px #ffffff;
        height: 70%;
    margin-bottom: 5px;
            width: 100%;
  }
  .cont_text{
    box-shadow: 1px 0px 40px #b8b8b8, -15px -15px 40px #ffffff;
    height: 49px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 16px;
    padding: 5px;
  }





  .dropDowm_item{
text-align: center;
    line-height: 50px;
    height: 100%;
    width: 50px;
    margin-right: 15px;
    writing-mode: vertical-lr;
      transition: all 0.5s ease-in-out;
    writing-mode: tb-lr;
    border-radius: 10px;
    box-shadow: 1px 0px 40px #b8b8b8, -15px -15px 40px #ffffff;
  }


@media (min-width: 500px) {
  .dropDowm_item{
text-align: center;
    line-height: 70px;
    height: 100%;
    width: 70px;
    margin-right: 15px;
     transition: all 0.5s ease-in-out;
    writing-mode: vertical-lr;
    writing-mode: tb-lr;
    border-radius: 10px;
    box-shadow: 1px 0px 40px #b8b8b8, -15px -15px 40px #ffffff;
  }
  .list_die{
    cursor: pointer;
     display: flex;
    height: 270px;
       width: 44%;
 transition: all 0.5s ease-in-out;
    margin: 20px;

  }
    .cont_img img{
  box-shadow: 1px 0px 40px #b8b8b8, -15px -15px 40px #ffffff;
        height: 65%;
    margin-bottom: 5px;
            width: 100%;
  }
  .list_item{
    max-width: 700px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin: auto;
}
}


  .dropDowm{
margin: 20px;
    background: #759d7a;
    padding: 10px;
  }
  .el-dropdown{
   color: white;
  }

  .small img{
    cursor: pointer;
    height: 100%;
    width: 100%;
  }
  .small_text{
  position: fixed;
    bottom: 24px;
    padding: 5px;
    text-align: center;
    width: 99%;
    background: #ffffffd6;
    font-size: 18px;
    font-weight: 700;

white-space: nowrap; /* 设置文本不换行 */
overflow: hidden; /* 隐藏溢出的内容 */
text-overflow: ellipsis; /* 将溢出的文本显示为省略号 */
    color: #000000;
  }


  .recommend{

  }
.recommend_die{
  cursor: pointer;
      display: flex;
    height: 100px;
 transition: all 0.5s ease-in-out;
    margin: 20px;
}


   .recommend_img{
display: flex;

width: 100%;


   }
  .recommend_img img{
      height: 100%;
    margin-bottom: 5px;
     width: 29%;

  }
  .recommend_text{
   box-shadow: -6px 9px 40px #b8b8b8, 20px 15px 20px #ffffff;
    height: 90px;
    width: 72%;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 5;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
    padding: 5px;
    
  }
    .recommend_text h3{
 width: 100%;

  
    overflow: hidden;
    text-overflow: ellipsis;
      display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
  }

  .recommend_text p{
 width: 100%;
 margin-top: 30px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    
  }

.footer{
    align-items: center;
    background: #679571;
    border-top: 1px solid var(--footer_border_color);
    display: flex;
    height: 40px;
    justify-content: space-around;
    left: 0;
    position: sticky;
    width: 100%;
    max-width: 700px;
    z-index: 2;
    bottom: 0px;
}

 .footer a {
    color: white;
    text-decoration: none;
    font-weight: 700;
}
/deep/ .el-icon-arrow-down:before {
    content: "\e6df";
    cursor: pointer;
}
</style>

